module.exports = __webpack_public_path__ + "img/hundred-years-page-bg.5646c07.svg";